import { Button, useTranslation } from '@hbs-us/ui';
import { Link } from '@tanstack/react-router';
import { FileText } from 'lucide-react';

/**
 * Empty-state card for the invoices list (legacy `InvoicesPage` empty-state).
 * Copy switches on the archived filter (UI-SPEC Copywriting Contract). The
 * brand `FileText` glyph replaces the legacy 🧾 emoji. The primary "New
 * invoice" CTA links to the create route (job-optional full-draft form) —
 * only shown on the non-archived empty state, matching the estimates/service
 * agreements empty-state convention.
 */
export function InvoicesEmptyState({ showArchived }: { showArchived: boolean }) {
  const { t } = useTranslation();

  return (
    <div className="rounded-md border border-border bg-card p-12">
      <div className="flex flex-col items-center gap-4 text-center">
        <FileText className="size-10 text-muted-foreground" aria-hidden="true" />
        <h2 className="font-display font-semibold text-foreground text-xl">
          {showArchived ? t('invoices:empty.archivedHeading') : t('invoices:empty.heading')}
        </h2>
        <p className="max-w-md text-muted-foreground text-sm">
          {showArchived ? t('invoices:empty.archivedBody') : t('invoices:empty.body')}
        </p>
        {showArchived ? null : (
          <Button asChild>
            <Link to="/invoices/new">{t('invoices:empty.cta')}</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
